import { LogoutModal, Modal, NewClientModal } from "@app/components";
import { Button } from "@app/controls";
import type { RootState } from "@app/redux";
import React from "react";
import { useSelector } from "react-redux";
import messages from "./messages";
import "./onboarding-in-progress-modal.css";
import type { ViewProperties } from "./properties";

export const OnboardingInProgressModalView = React.memo(
	(props: ViewProperties) => {
		const { language } = useSelector(
			(rootState: RootState) => rootState.language,
		);

		const buttonStyle = ["mt-9.5", "change-client", "mx-auto"].join(" ");

		return (
			<>
				{props.showLogoutModal && (
					<LogoutModal open onClose={props.onCloseLogoutModal} />
				)}
				{props.showNewClientModal && (
					<NewClientModal open onClose={props.onToggleAddClient} />
				)}
				{props.open && !props.showLogoutModal && !props.showNewClientModal && (
					<Modal className="onboarding-in-progress-modal" open noCloseButton>
						<h1 className="font-bold text-2xl mb-8">
							{messages[language].header}
						</h1>
						<p>{messages[language].paragraph1}</p>
						<br />
						<p>{messages[language].paragraph2}</p>
						<br />
						<p>{messages[language].furtherAssistance}</p>
						<a
							href={`mailto:${messages[language].onboardingUrl}`}
							target="_blank"
							rel="noreferrer"
						>
							{messages[language].onboardingUrl}
						</a>
						<div className="flex flex-row gap-x-1">
							{
								<Button
									className={buttonStyle}
									type="button"
									theme="primary"
									onClick={() =>
										props.clients.length > 1
											? props.onNavigateClients()
											: props.onToggleAddClient()
									}
								>
									{props.clients.length > 1
										? messages[language].back
										: messages[language].addClient}
								</Button>
							}
							<Button
								className={buttonStyle}
								type="button"
								theme="primary"
								onClick={props.onLogout}
							>
								{messages[language].logout}
							</Button>
						</div>
					</Modal>
				)}
			</>
		);
	},
);
